import { useDispatch } from 'react-redux';
import { debounce } from 'lodash';
import { getAggregationsAction } from '../../containers/App/actions';

export default function useAggregationFilter(endpoint) {
  const dispatch = useDispatch();

  return debounce((filterType, value, filters) => {
    const aggregationFilters = filters || {};
    dispatch(
      getAggregationsAction({
        endpoint,
        query: {
          aggregation_type: filterType,
          aggregation_query: value,
          ...aggregationFilters,
        },
      }),
    );
  }, 300);
}
